import FormPage from '@/components/FormPage'
import { createGetParams, createPostParams } from '@/rest'
import {
  formatPhoneNumber,
  getRm,
  getNumeralFromRm,
  stringGen,
} from '@/utils'

const formTitle = 'Topup/Pay bill'

export default {
  extends: FormPage,
  data () {
    return {
      name: null,
      street1: null,
      street2: null,
      city: null,
      postalCode: null,
      state: null,
      isPrepaid: true,
      planCategory: null,
      isSubmiting: false,
      lastSubmitTime: null,
      breadcrumbs: [
        {
          text: 'Dealer Kits', disabled: false, to: '/dealer_kits',
        },
        {
          text: formTitle, disabled: true,
        },
      ],
      title: formTitle,
      // Form steps
      paymentDetails: {
        fields: {
          erprepaid: {
            name: 'Prepaid balance',
          },
          erblack: {
            name: 'Postpay balance',
          },
          msisdn: {
            component: () => import(/* webpackChunkName: "msisdnField" */ '@/components/MsisdnField'),
            name: 'Mobile number',
            props: {
              existing: true,
              hint: 'Mobile number',
              label: 'Enter mobile number',
              presistentHint: true,
              required: true,
              rules: [val => !!val || 'Mobile number required!'],
              searchNetwork: true,
            },
          },
          plan: {
            name: 'Mobile plan',
          },
          amountDue: {
            name: 'Amount due',
          },
          payment: {
            component: () => import(/* webpackChunkName: "amountField" */ '@/components/AmountField'),
            name: 'Payment',
            props: {
              label: 'Enter amount to pay',
              required: true,
              rules: [],
            },
          },
        },
        subTitle: 'Account information & payment',
        title: 'Payment details',
      },
      submission: {
        fields: {
          msisdn: {
            name: 'Mobile number',
          },
          plan: {
            name: 'Plan',
          },
          amountDue: {
            name: 'Amount due',
          },
          payment: {
            emphasize: true,
            name: 'Payment',
          },
        },
        submit: false,
        errorMessage: null,
        status: null,
        subTitle: 'Check before submit',
        title: 'Submit',
      },
    }
  },
  computed: {
    formSteps: function () {
      return {
        paymentDetails: this.paymentDetails,
        submission: this.submission,
      }
    },
    erprepaid: function () {
      return this.paymentDetails.fields.erprepaid
    },
    erblack: function () {
      return this.paymentDetails.fields.erblack
    },
    payment: function () {
      return this.paymentDetails.fields.payment.value
    },
  },
  mounted: function () {
    this.paymentDetails.fields.payment.props.rules.push(
      () => this.validatePayment(),
    )
    const params = createGetParams({
      erecharge: true,
      erechargeBlack: true,
    })
    this.$rest.get('getDealerResources.php', params).then(function (response) {
      this.erprepaid.error = null
      this.erblack.error = null
      this.erprepaid.value = getRm(response.data.erecharge)
      this.erblack.value = getRm(response.data.erechargeBlack)
    }.bind(this)).catch(error => {
      this.erprepaid.error = error.message
      this.erblack.error = error.message
    })
  },
  watch: {
    'paymentDetails.fields.msisdn.value': function (val) {
      this.submission.fields.msisdn.value = formatPhoneNumber(val)
      if (!val) return

      setTimeout(() => {
        if (!this.paymentDetails.fields.msisdn.error &&
          ((val.length === 11 && val.startsWith('011')) || (val.length === 10 && !val.startsWith('011')))) {
          const params = createGetParams({
            target: this.paymentDetails.fields.msisdn.value,
          })
          this.$rest.get('getAmountDue2.php', params)
            .then(response => {
              const plan = response.data.plan
              if (plan === '' || plan === 'WAWA' || plan === 'ONE-X' || plan === 'JS') {
                this.planCategory = 'Prepaid'
                this.isPrepaid = true
                this.paymentDetails.fields.amountDue.value = null
              } else if (plan === 'ONEFamily' || plan === 'FamFlex59') {
                this.planCategory = 'Family'
                this.isPrepaid = false
                this.paymentDetails.fields.amountDue.value = getRm(response.data.amountDue)
              } else if (plan === 'SISWA_PLUS') {
                this.planCategory = 'Siswa'
                this.isPrepaid = false
                this.paymentDetails.fields.amountDue.value = getRm(response.data.amountDue)
              } else if (plan === 'WIFI_PREMIUM' || plan === 'WIFI_PLUS') {
                this.planCategory = 'XOXWifi'
                this.isPrepaid = false
                this.paymentDetails.fields.amountDue.value = getRm(response.data.amountDue)
              } else {
                this.planCategory = 'Black'
                this.isPrepaid = false
                this.paymentDetails.fields.amountDue.value = getRm(response.data.amountDue)
              }
              this.paymentDetails.fields.plan.value = plan === '' ? 'Prepaid' : plan
              this.name = response.data.name
              this.street1 = response.data.street1 ? response.data.street1 : null
              this.street2 = response.data.street2 ? response.data.street2 : null
              this.city = response.data.city ? response.data.city : null
              this.postalCode = response.data.postalCode ? response.data.postalCode : null
              this.state = response.data.state ? response.data.state : null
              this.planCategory = this.planCategory ? this.planCategory : null
            }).catch(() => {
            // ignore
            })
        } else {
          this.paymentDetails.fields.plan.value = null
          this.paymentDetails.fields.amountDue.value = null
        }
      }, 1000)
    },
    'paymentDetails.fields.payment.value': function (val) {
      this.submission.fields.payment.value = getRm(val)

      if (this.planCategory === 'Prepaid') {
        if (Number(val) > getNumeralFromRm(this.erprepaid.value)) {
          this.paymentDetails.fields.payment.validate && this.paymentDetails.fields.payment.validate(true)
        } else {
          this.submission.fields.payment.value = getRm(val)
          this.paymentDetails.fields.payment.validate && this.paymentDetails.fields.payment.validate()
        }
      } else {
        if (Number(val) > getNumeralFromRm(this.erblack.value)) {
          this.paymentDetails.fields.payment.validate && this.paymentDetails.fields.payment.validate(true)
        } else {
          this.submission.fields.payment.value = getRm(val)
          this.paymentDetails.fields.payment.validate && this.paymentDetails.fields.payment.validate()
        }
      }
    },
    'paymentDetails.fields.amountDue.value': function (val) {
      this.submission.fields.amountDue.value = val
    },
    'paymentDetails.fields.plan.value': function (val) {
      this.submission.fields.plan.value = val
    },
  },
  methods: {
    validatePayment: function () {
      if (Number(this.payment) <= 0) return 'Payment amount required!'
      if (this.planCategory === 'Prepaid' && Number(this.payment) > getNumeralFromRm(this.erprepaid.value)) return 'Insufficient e-recharge!'
      if (this.planCategory !== 'Prepaid' && Number(this.payment) > getNumeralFromRm(this.erblack.value)) return 'Insufficient postpay e-recharge!'
      return true
    },
    // Override
    async submit () {
      const now = Date.now()

      // If already submitting, show error
      if (this.isSubmitting) {
        const elapsed = (now - this.lastSubmitTime) / 1000 // in seconds
        if (elapsed < 60) {
          this.status = this.submission.status = 'error'
          this.submission.errorMessage = 'Submission already in progress. Please wait.'
          return
        }
      }

      this.isSubmitting = true
      this.lastSubmitTime = now

      const params = createPostParams({
        action: 'reloads',
        payload: {
          target: this.paymentDetails.fields.msisdn.value,
          amount: Number(this.paymentDetails.fields.payment.value).toFixed(2),
          outstanding: getNumeralFromRm(this.paymentDetails.fields.amountDue.value).toFixed(2),
          planCategory: this.planCategory,
        },
      })

      try {
        const response = await this.$rest.post('postAction.php', params)
        this.$nextTick(() => {
          this.alertText = 'Your request to make a Prepaid topup or bill payment was successfully submitted.'
          this.status = this.submission.status = 'success'
          this.submission.submit = false
          this.isImpersonated() && this.showSubmissionResponse(response.data)
          // this.downloadReceipt()
        })
      } catch (e) {
        this.$nextTick(() => {
          this.status = this.submission.status = 'error'
          this.submission.errorMessage = e.message + ': ' + e.response.data
          this.submission.submit = false
        })
      } finally {
        // Optional: keep isSubmitting = true for 60s to prevent more submits
        setTimeout(() => {
          this.isSubmitting = false
        }, 60000) // 60 seconds
      }
    },
    async downloadReceipt () {
      const prefix = this.isPrepaid ? 'P-' : 'B-'
      let invoice = prefix + stringGen(9)
      invoice = invoice.toUpperCase()

      const payload = {
        msisdn: this.paymentDetails.fields.msisdn.value,
        amount: this.paymentDetails.fields.payment.value,
        invoice: invoice,
        name: this.name,
        street1: this.street1,
        street2: this.street2,
        city: this.city,
        postalCode: this.postalCode,
        state: this.state,
      }

      const data = process.env.NODE_ENV === 'production' ? { payload: payload }
        : { impersonate: 223992, payload: payload }
      try {
        const response = await this.$rest({
          url: process.env.NODE_ENV === 'production' ? location.protocol + '//' + location.hostname + (this.isPrepaid ? 'api/pdf/topupReceipt.php' : '/api/pdf/billPaymentReceipt.php')
            : (this.isPrepaid ? 'http://203.115.197.112/pdf/topupReceipt.php' : 'http://203.115.197.112/pdf/billPaymentReceipt.php'),
          method: 'POST',
          responseType: 'blob',
          data: data,
        })

        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.setAttribute('download', this.isPrepaid ? 'prepaid_topup_resit.pdf' : 'black_bill_payment_resit.pdf')
        document.body.appendChild(link)
        link.click()
      } catch (e) {}
    },
  },
}
